import { ReactComponent as chevron } from './chevron.svg';
import { ReactComponent as close } from './close.svg';
import { ReactComponent as sadBaseball } from './sadBaseball.svg';
import { ReactComponent as mlbLogo } from './mlbLogo.svg';

export const ChevronIcon = chevron;
export const CloseIcon = close;
export const SadBaseballIcon = sadBaseball;
export const MlbLogo = mlbLogo;
